export default "__VITE_ASSET__8aa5a8e4__"